import React from 'react';

const Trending = () => {
    return (
        <div>
            trending
        </div>
    );
};

export default Trending;